import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 1600px;
    margin: auto;
    padding: 0 20px;

    @media (max-width: 1600px) {
        width: 100%;
        padding: 0 20px;
    }
`

export const ContainerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: left;
    width: 100%;
`
